import script from "./TransactionModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./TransactionModal.vue?vue&type=script&lang=ts&setup=true"

import "./TransactionModal.vue?vue&type=style&index=0&id=c9a88c36&lang=scss"

const __exports__ = script;

export default __exports__